module.exports = __webpack_public_path__ + "img/apple-store-badge.0f3514a4.svg";